// import request from '@/utils/request'
import { get, post,put,remove } from '@/utils/http.js'

// 查询消防设施管理列表
// export function listFireFacilitiesManage(query) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage/list',
//     method: 'get',
//     params: query
//   })
// }
export const listFireFacilitiesManage = (query)=>get('/trmoni/fireFacilitiesManage/list',query)

// 查询消防设施管理详细
// export function getFireFacilitiesManage(id) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage/' + id,
//     method: 'get'
//   })
// }
export const getFireFacilitiesManage = (id)=>get('/trmoni/fireFacilitiesManage/' + id)

// 新增消防设施管理
// export function addFireFacilitiesManage(data) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage',
//     method: 'post',
//     data: data
//   })
// }
export const addFireFacilitiesManage = (data)=>post('/trmoni/fireFacilitiesManage',data)

// 修改消防设施管理
// export function updateFireFacilitiesManage(data) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage',
//     method: 'put',
//     data: data
//   })
// }
export const updateFireFacilitiesManage = (data)=>put('/trmoni/fireFacilitiesManage',data)

// 删除消防设施管理
// export function delFireFacilitiesManage(id) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage/' + id,
//     method: 'delete'
//   })
// }
export const delFireFacilitiesManage = (id)=>remove('/trmoni/fireFacilitiesManage/' + id)

// 导出消防设施管理
// export function exportFireFacilitiesManage(query) {
//   return request({
//     url: '/v1/trmoni/fireFacilitiesManage/export',
//     method: 'get',
//     params: query
//   })
// }
export const exportFireFacilitiesManage = (query)=>get('/trmoni/fireFacilitiesManage/export',query)
